function getout(val,vm) {
  vm.octopus.tips.debug("已加载：" + val + " | use out js -> getout")
}

// ES6特性，然后外部可通过import命令可以为该匿名函数指定任意名字
export default {
  getout
}



// WEBPACK FOOTER //
// ./src/assets/js/out.js